import { scroller, animateScroll } from 'react-scroll';

import { PAGE_ELEMENT_ID } from '@core/Page/constants';

export interface ScrollToParams {
    id: string;
    offset?: number;
    sectionName?: string;
    containerId?: string;
    target?: string;
    horizontal?: boolean;
}

export class Scroller {
    public static SCROLL_OFFSET = -48;
    public static SCROLL_DURATION = -300;

    public static scrollTo({
        sectionName = 'section',
        target,
        offset,
        id,
        containerId,
        horizontal = false,
    }: Partial<ScrollToParams>) {
        const name = `${sectionName}_${id}`;

        const options = {
            horizontal,
            offset: offset ?? Scroller.SCROLL_OFFSET,
            target: target ?? name,
            smooth: 'easeOutQuad',
            duration: Scroller.SCROLL_DURATION,
            containerId: containerId || PAGE_ELEMENT_ID,
        };

        scroller.scrollTo(target ?? name, options);
    }

    public static scrollMore(toY: number, params?: ScrollToParams) {
        const options = {
            smooth: 'easeOutQuad',
            duration: 0,
            delay: 0,
            containerId: (params && params.containerId) || PAGE_ELEMENT_ID,
        };

        animateScroll.scrollMore(toY, options);
    }

    public static scrollToTop(params?: Partial<ScrollToParams>) {
        animateScroll.scrollToTop({
            smooth: 'easeOutQuad',
            duration: Scroller.SCROLL_DURATION,
            containerId: PAGE_ELEMENT_ID,
            ...params,
        });
    }

    public static get(id: string): HTMLElement {
        return scroller.get(id);
    }
}
